export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const ENDPOINTS = {
  webhook: `${SUPABASE_URL}/rest/v1/rpc/process_webhook_request`
} as const;